export const OPERATOR_IS = 'is';
export const OPERATOR_IS_ONE_OF = 'is_one_of';
